export const MENU = [
  {
    name: 'Методики рассчета',
    link: '',
  },
  {
    name: 'О проекте',
    link: '',
  },
  {
    name: 'Блог',
    link: '',
  },
  {
    name: 'Контакты',
    link: '',
  },
];

interface BenefitsType {
  id: number;
  title: string;
  description: string;
}

export const BENEFITS: BenefitsType[] = [
  {
    id: 1,
    title: 'Уникальное понимание талантов и сильных сторон',
    description:
      'Наши расчеты помогут вам выявить скрытые таланты и сильные стороны, ' +
      'о которых вы, возможно, не подозревали. ',
  },
  {
    id: 2,
    title: 'Осознанные решения',
    description:
      'Знание своих сильных и слабых сторон позволяет принимать более взвешенные и обдуманные решения. ' +
      'Вы сможете лучше понимать свои мотивы и цели, что приведет к более успешным и удовлетворяющим результатам.',
  },
  {
    id: 3,
    title: 'Улучшение отношений',
    description: 'Понимание своей личности и особенностей других людей способствует улучшению взаимоотношений.',
  },
  {
    id: 4,
    title: 'Успех в личной и профессиональной жизни',
    description:
      'Осознание своего предназначения и жизненных задач поможет вам выбрать правильный путь и ' +
      'добиваться поставленных целей. ',
  },
];
